import type { FC } from 'react';

import { ModalBody } from 'Features/SellerCommunications/components/ModalBody';
import { ModalHeader } from 'Features/SellerCommunications/components/ModalHeader';
import { T } from 'Features/SellerCommunications/utils/translate';

import { EnquirySelectionFooter } from './EnquirySelectionFooter';
import { EnquirySelectionList } from './EnquirySelectionList';
import { EnquirySelectionListLimitInfo } from './EnquirySelectionListLimitInfo';

export const EnquirySelection: FC = () => {
	return (
		<>
			<ModalHeader description={T.translate('enquiryList.description')} title={T.translate('enquiryList.title')} />
			<EnquirySelectionListLimitInfo />
			<ModalBody>
				<EnquirySelectionList />
			</ModalBody>
			<EnquirySelectionFooter />
		</>
	);
};
